export enum FlightProviderEnum {
  AMADEUS_QUICK_CONNECT = 'AMADEUS_QUICK_CONNECT',
  AMADEUS_INSTANT_SEARCH = 'AMADEUS_INSTANT_SEARCH',
  DUFFEL = 'DUFFEL',
  TRAVELPORT_UNIVERSAL_API = 'TRAVELPORT_UNIVERSAL_API',
  PULPO = 'PULPO',
}
